import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Row, Col } from "react-bootstrap";
import flattenDeep from "lodash/flattenDeep";
import uniq from "lodash/uniq";

import WeekPicker from "../common/DatePicker/WeekPicker";
import StudentSteps from "../common/StudentSteps";
import * as runActions from "../../actions/runsActionCreators";
import * as studentActions from "../../actions/studentsActionCreators";
import * as coursesActions from "../../actions/coursesActionCreators";
import Spinner from "react-spinkit";
import ClassesList from "../classes/List";
import SchedulesViewContainer from "./ScheduleViewAddDrop/SchedulesViewContainer";
import { getClassesInRangeByFilters } from "../../utils/utils";
import MessageAddDropIsClosed from "./MessageAddDropIsClosed";

class StudentAddDropContainer extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      run: {},
      student: {},
      studentLoaded: false,
      assignmentsLoaded: false,
      selectedWeekDays: null,
    };

    this.handleGetStartedFormSubmit = this.handleGetStartedFormSubmit.bind(this);
  }

  componentDidMount() {
    if (!this.props.run.id) {
      this.props.runActions.getRun().then(() => {
        this.props.studentActions.getAssignment();
      });
    } else if (this.props.assignments.length === 0) {
      this.props.studentActions.getAssignment();
    }
    if (this.props.courses.length == 0) {
      this.props.coursesActions.getAllCourses().finally(() => {
        this.setState({ assignmentsLoaded: true });
      });
    } else {
      this.setState({ assignmentsLoaded: true });
    }
    if (!this.props.student.id) {
      this.props.studentActions.getStudent().then(() => {
        this.props.runActions.getAllRankPreferences();
      });
    } else {
      this.setState({ student: this.props.student, studentLoaded: true });
    }
  }

  getMinMaxDateFromAssignments = () => {
    const { assignmentsLoaded } = this.state;
    const { assignments, courses } = this.props;

    if (assignmentsLoaded) {
      // Map courses to assignments and return the meetings
      const mappedCoursesToAssignments = assignments.map((a) => {
        const matchedCourse = courses.find((c) => c.id === a.course);

        if (matchedCourse) {
          return { ...a, meetings: matchedCourse.meetings };
        }

        return a;
      });

      // reduce meetings to a flat array of meetings
      const meetingCourses = mappedCoursesToAssignments.reduce((prev, curr) => {
        const meetings = curr.meetings.map((m) => [m.startdate, m.enddate]);

        return [...prev, ...flattenDeep(meetings)];
      }, []);

      const uniqueMeetings = uniq(meetingCourses);

      uniqueMeetings.sort((a, b) => new Date(a) - new Date(b)); // sort metting dates asc.

      return {
        minDate: uniqueMeetings[0],
        maxDate: uniqueMeetings[uniqueMeetings.length - 1],
      };
    }
  };

  parseAssignment = (items = []) => {
    const { courses = [] } = this.props;
    const { selectedWeekDays } = this.state;

    if (courses.length === 0) return [];
    let courseItems = items.map((item) => {
      const course = courses.filter((course) => course.id === item.course)[0] || {};
      const inRange =
        course &&
        course.meetings.reduce((prev, curr) => {
          const { enddate, startdate } = curr;
          const classInRange = getClassesInRangeByFilters(startdate, enddate, selectedWeekDays);

          return prev && classInRange;
        }, true);
      return { weight: course.weight, inRange };
    });

    const weightList = courseItems.filter((i) => i.inRange).map((w) => w.weight);
    return weightList.reduce(function (a, b) {
      return a + b;
    }, 0);
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.student.id) {
      this.setState({ student: nextProps.student });
      this.setState({ studentLoaded: true });
    }
    if (nextProps.run !== this.props.run) {
      this.setState({ run: nextProps.run });
    }
  }

  handleGetStartedFormSubmit(values) {
    this.setState({ studentLoaded: false });
    let obj = {
      target_course_units: +values.target_course_units,
      max_course_units: +values.max_course_units,
    };
    this.props.studentActions.setTarget(obj);
  }

  handleSelectWeek = (weekDays) => {
    this.setState({ selectedWeekDays: weekDays });
  };

  renderLoadingSpinner = () => (
    <div className="spinner-box">
      <Spinner spinnerName="three-bounce" className="mt-4" />
    </div>
  );

  renderContent() {
    if (!this.props.run.add_drop_visible_to_students) {
      return (
        <div>
          {this.props.run.additional_manage_schedule != null ? (
            <Row>
              <Col md={9}>
                <p
                  className="mb-2 lead"
                  dangerouslySetInnerHTML={{
                    __html: this.props.run.additional_manage_schedule.replace(
                      "[[[primary_contact_email]]]",
                      `<a href="mailto:${this.props.run.primary_contact}">${this.props.run.primary_contact}</a>`
                    ),
                  }}
                ></p>
              </Col>
            </Row>
          ) : null}
          <MessageAddDropIsClosed email={this.props.run.primary_contact} />
        </div>
      );
    }
    const { assignments, student } = this.props;
    const { assignmentsLoaded, selectedWeekDays } = this.state;
    let totalCredits = this.parseAssignment(student.assignments);
    const ranges = this.getMinMaxDateFromAssignments();
    const renderCredit = (credits) => (parseFloat(credits) === 1.0 ? `${credits} credit` : `${credits} credits`);

    return (
      <div>
        {this.props.run.additional_manage_schedule != null ? (
          <Row>
            <Col md={9}>
              <p
                className="mb-2 lead"
                dangerouslySetInnerHTML={{
                  __html: this.props.run.additional_manage_schedule.replace(
                    "[[[primary_contact_email]]]",
                    `<a href="mailto:${this.props.run.primary_contact}">${this.props.run.primary_contact}</a>`
                  ),
                }}
              ></p>
            </Col>
          </Row>
        ) : null}
        {this.props.run.id && assignmentsLoaded ? (
          <div>
            <Row>
              <Col md={9}>
                <h2 className="page-subtitle">Classes ({renderCredit(totalCredits)})</h2>
              </Col>
              <Col md={3} style={{ top: "22px" }}>
                <WeekPicker
                  handleSelectWeek={this.handleSelectWeek}
                  minDate={ranges.minDate}
                  maxDate={ranges.maxDate}
                  inputClassNames="week-picker-auto-width"
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <ClassesList filteredDays={selectedWeekDays} />
              </Col>
            </Row>
            <h2 className="page-subtitle mt-6">Schedule</h2>

            <Row>
              <Col md={12}>
                <SchedulesViewContainer
                  assignments={assignments}
                  assignmentsLoaded={assignmentsLoaded}
                  filteredDays={selectedWeekDays}
                />
              </Col>
            </Row>
          </div>
        ) : (
          this.renderLoadingSpinner()
        )}
      </div>
    );
  }

  render() {
    return (
      <div>
        <Row>
          <Col md={12}>
            {/* <div className="page-title">Schedules</div> */}
            <StudentSteps active={0} isAssignmentCompleted={true} />
            {this.renderContent()}
          </Col>
        </Row>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    run: state.run,
    student: state.student,
    courses: state.courses,
    assignments: state.assignments,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    runActions: bindActionCreators(runActions, dispatch),
    studentActions: bindActionCreators(studentActions, dispatch),
    coursesActions: bindActionCreators(coursesActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentAddDropContainer);



// WEBPACK FOOTER //
// ./src/components/rank/StudentAddDropContainer.js